import { Component, Input, ChangeDetectionStrategy, inject, DestroyRef, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import {
  HooksHttpService,
  CursorHookType,
  HookOsType,
  CURSOR_HOOKS,
} from 'src/app/services/httpServices/hooksHttpService/hooks-http.service';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';

@Component({
  selector: 'app-cursor-hooks-download',
  standalone: true,
  imports: [CommonModule, LabelsProviderPipe],
  templateUrl: './cursor-hooks-download.component.html',
  styleUrl: './cursor-hooks-download.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CursorHooksDownloadComponent {
  @Input() public integrationId: string | undefined;
  @Input() public hasEnrollmentKey = false;

  private readonly _hooksHttpService = inject(HooksHttpService);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _logger = inject(LoggerService);

  public readonly hooks: CursorHookType[] = CURSOR_HOOKS;
  public readonly selectedOs = signal<HookOsType>('macLinux');

  public selectOs(os: HookOsType): void {
    this.selectedOs.set(os);
  }

  public downloadHook(hook: CursorHookType): void {
    if (!this.integrationId) {
      return;
    }

    const os = this.selectedOs();
    const ext = os === 'windows' ? 'ps1' : 'sh';

    this._hooksHttpService
      .downloadHookScript('cursor', hook, this.integrationId, os)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `zenity-cursor-${hook}.${ext}`;
          a.click();
          URL.revokeObjectURL(url);
        },
        error: (error) => {
          this._logger.error('Failed to download hook script:', error);
        },
      });
  }

  public downloadAllHooks(): void {
    for (const hook of this.hooks) {
      this.downloadHook(hook);
    }
  }
}
